import React from 'react';
import PropTypes from 'prop-types';
import './UnderlinedText.css';

const UnderlinedText = ({ text, underlineColour = '#FFD700' }) => {
  return (
    <div className="underlined-text-container" data-aos="flip-up">
      <h2>{text}</h2>
      <div
        className="underline"
        style={{
          backgroundColor: { underlineColour },
        }}
      />
    </div>
  );
};

UnderlinedText.propTypes = {
  text: PropTypes.string.isRequired,
};

export default UnderlinedText;
